<template>
  <div class="image-selector">
    <div class="selector-row">
      <el-select
        v-model="innerCategoryCode"
        placeholder="请选择图片类别"
        style="width: 220px"
        :disabled="filteredCategories.length <= 1"
        @change="handleCategoryChange"
      >
        <el-option
          v-for="item in filteredCategories"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
      <el-select
        v-model="selectedIds"
        filterable
        clearable
        :multiple="multiple"
        :collapse-tags="multiple"
        style="flex: 1"
        :placeholder="multiple ? '请选择图片，可多选' : '请选择图片'"
        @change="emitValue"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.optionLabel"
          :value="item.id"
        />
      </el-select>
    </div>

    <div v-if="selectedItems.length" class="preview-row">
      <div v-for="item in selectedItems" :key="item.id" class="preview-item">
        <el-image
          :src="resolveFileUrl(item.accessUrl)"
          :preview-src-list="previewUrlList"
          fit="cover"
          class="preview-image"
        >
          <div slot="error" class="preview-error">加载失败</div>
        </el-image>
        <div class="preview-text">#{{ item.id }} {{ item.fileName }}</div>
      </div>
    </div>
    <div v-else class="preview-empty">未选择图片</div>
  </div>
</template>

<script>
import http from '../../utils/http'
import { resolveFileUrl } from '../../utils/file'

export default {
  name: 'ImageSelector',
  props: {
    value: {
      type: [String, Array],
      default: () => []
    },
    categoryCode: {
      type: String,
      default: ''
    },
    allowedCategories: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      categories: [],
      options: [],
      innerCategoryCode: '',
      selectedIds: this.multiple ? [] : null,
      initializing: true
    }
  },
  computed: {
    filteredCategories () {
      if (!this.allowedCategories.length) {
        return this.categories
      }
      return this.categories.filter(item => this.allowedCategories.includes(item.code))
    },
    selectedItems () {
      const selectedIdList = this.multiple
        ? (Array.isArray(this.selectedIds) ? this.selectedIds : [])
        : (this.selectedIds ? [this.selectedIds] : [])
      return selectedIdList
        .map(id => this.options.find(item => item.id === id))
        .filter(Boolean)
    },
    previewUrlList () {
      return this.selectedItems
        .map(item => this.resolveFileUrl(item.accessUrl))
        .filter(Boolean)
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        this.syncSelectedIdsFromValue()
      }
    },
    categoryCode (value) {
      if (value && value !== this.innerCategoryCode) {
        this.innerCategoryCode = value
        this.loadOptions()
      }
    }
  },
  async created () {
    await this.loadCategories()
    this.innerCategoryCode = this.resolveInitialCategory()
    if (this.innerCategoryCode) {
      await this.loadOptions()
    }
    this.initializing = false
  },
  methods: {
    resolveFileUrl,
    async loadCategories () {
      const { data } = await http.get('/mall/image-resource/category-options')
      this.categories = data.data || []
    },
    resolveInitialCategory () {
      if (this.categoryCode && this.filteredCategories.some(item => item.code === this.categoryCode)) {
        return this.categoryCode
      }
      return this.filteredCategories.length ? this.filteredCategories[0].code : ''
    },
    async loadOptions () {
      if (!this.innerCategoryCode) {
        this.options = []
        this.selectedIds = this.multiple ? [] : null
        return
      }
      const { data } = await http.get('/mall/image-resource/options', {
        params: { categoryCode: this.innerCategoryCode }
      })
      this.options = data.data || []
      this.syncSelectedIdsFromValue()
      this.$emit('update:categoryCode', this.innerCategoryCode)
    },
    async handleCategoryChange () {
      this.selectedIds = this.multiple ? [] : null
      await this.loadOptions()
      if (this.initializing) {
        return
      }
      this.emitValue()
    },
    syncSelectedIdsFromValue () {
      if (!this.options.length) {
        return
      }
      if (this.multiple) {
        const urls = Array.isArray(this.value) ? this.value : []
        this.selectedIds = this.options
          .filter(item => urls.includes(item.accessUrl))
          .map(item => item.id)
      } else {
        const value = typeof this.value === 'string' ? this.value : ''
        const matched = this.options.find(item => item.accessUrl === value)
        this.selectedIds = matched ? matched.id : null
      }
    },
    emitValue () {
      const selectedItems = this.selectedItems
      if (this.multiple) {
        this.$emit('input', selectedItems.map(item => item.accessUrl))
      } else {
        this.$emit('input', selectedItems.length ? selectedItems[0].accessUrl : '')
      }
      this.$emit('update:categoryCode', this.innerCategoryCode)
    }
  }
}
</script>

<style scoped>
.image-selector {
  width: 100%;
}

.selector-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.preview-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}

.preview-item {
  width: 120px;
}

.preview-image {
  width: 120px;
  height: 120px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  display: block;
  cursor: pointer;
}

.preview-text {
  margin-top: 6px;
  font-size: 12px;
  color: #606266;
  word-break: break-all;
}

.preview-empty {
  margin-top: 10px;
  color: #909399;
  font-size: 12px;
}

.preview-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #f5f7fa;
}
</style>
